import React from 'react';
import PropTypes from 'prop-types';
import kebabCase from 'lodash/kebabCase';

import PaymentMethodModel from 'models/payment-method';
import UserModel from 'models/user';

const propTypes = {
  paymentMethod: PropTypes.instanceOf(PaymentMethodModel).isRequired,
  user: PropTypes.instanceOf(UserModel).isRequired,
  deleteMethod: PropTypes.func.isRequired,
  editMethod: PropTypes.func.isRequired,
  connectMethod: PropTypes.func.isRequired,
};

const BusinessProfile = ({ paymentMethod, user, deleteMethod, editMethod, connectMethod }) => {
  let connectionInfo = [];

  if (user.authorizedServices.get('concur')) {
    connectionInfo = connectionInfo.concat(
      <div className="text-color-medium-grey clickable" onClick={connectMethod} key="concur">
        <span className="iconified-font iconified-link h6-sg iconified-space-right-half with-vertical-margin-half" />
        Bookings are linked to Concur
      </div>,
    );
  }

  if (user.authorizedServices.get('expensify')) {
    connectionInfo = connectionInfo.concat(
      <div className="text-color-medium-grey clickable" onClick={connectMethod} key="expensify">
        <span className="iconified-font iconified-link h6-sg iconified-space-right-half with-vertical-margin-half" />
        Bookings are linked to Expensify
      </div>,
    );
  }

  if (connectionInfo.length === 0) {
    connectionInfo = connectionInfo.concat(
      <div className="text-color-medium-grey clickable" onClick={connectMethod}key="neither">
        <span className="iconified-font iconified-link text-color-light-grey h6-sg iconified-space-right-half with-vertical-margin-half" />
        Link to Concur or Expensify
      </div>,
    );
  }

  return (
    <div>
      <div className="card-body text-weight-light">
        <div className="vertical-padding-bottom">
          <strong>Business Profile <span className="iconified-font iconified-briefcase" /></strong>
        </div>
        <div className="with-bottom-margin-half">
          <span className={`iconified iconified-space-right iconified-${kebabCase(paymentMethod.cardType)}`} />
          &bull;&bull;&bull;&bull;&nbsp;
          {paymentMethod.lastFourDigits}
        </div>
        {connectionInfo}
      </div>
      <div className="card-footer text-center">
        <div className="row">
          <div className="col-xs-6 padding-left-2x padding-right-0 text-left" onClick={editMethod}>
            <span className="edit text-weight-medium clickable">EDIT PROFILE</span>
          </div>
          <div className="col-xs-6" onClick={deleteMethod}>
            <span className="delete text-weight-medium clickable">DELETE</span>
          </div>
        </div>
      </div>
    </div>
  );
};

BusinessProfile.propTypes = propTypes;

export default BusinessProfile;
